import "../../stylesNewPromotion.css";

export const StepIndicator = ({ number, label, isActive, setStepIndicators }) => {
  return (
    <div className="stepWrapper"
      onClick={() => {
        setStepIndicators((prev) =>
          prev.map((step) => (step.id === number ? { ...step, isActive: true } : { ...step, isActive: false }))
        );
      }}
    >
      <div className={isActive ? "stepNumber stepNumberActive" : "stepNumber"}>
        {number}
      </div>
      <div className={isActive ? "stepLabelActive" : "stepLabel"}>{label}</div>
    </div>
  );
};
